import { useTranslation } from "react-i18next";
import { TableSearchNoMatch } from "../../../common/entity-table/TableSearchNoMatch";

export const ContractSearchNoMatch = ({
  term,
  activeFilters,
  onClearSearch,
  onResetFilters,
}: {
  term: string;
  activeFilters: string[];
  onClearSearch: () => void;
  onResetFilters: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <TableSearchNoMatch
      heading={t("No contracts contain «{{term}}»", { term: term.trim() })}
      searchedIn={t("The search looks in Title, Counterparty, Reference, Projects, Responsible and Department.")}
      foundElsewhere={t("Dates, amounts, status and custom fields are found with + Filter.")}
      filtersNote={
        activeFilters.length > 0
          ? t("The search only covers the contracts that match the filters: {{filters}}.", {
              filters: activeFilters.join(", "),
            })
          : null
      }
      onClearSearch={onClearSearch}
      onResetFilters={onResetFilters}
    />
  );
};
